export const MaximiseIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M1.7 15H5V16H0V11H1V14.3L5.8 9.48999L6.51 10.2L1.7 15Z" fill="currentColor" />
            <path
                d="M16.0002 0V5H15.0002V1.7L10.2002 6.51L9.49023 5.8L14.3002 1H11.0002V0H16.0002Z"
                fill="currentColor"
            />
        </svg>
    );
};
